'use strict'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import './CategoryMenu.scss'
import CategoryMenuPanel from './CategoryMenuPanel'
import CategoryMenuData from './CategoryMenuData'

class CategoryTiles extends PureComponent {
  render () {
    const tiles = CategoryMenuData

    if (!this.props.setTile) {
      return (
        <div className='xs-row xs-row--negative md-row'>
          {tiles.map((tile, index) => {
            return (
              <div className='xs-12 md-4' key={index}>
                <CategoryMenuPanel {...tile} />
              </div>
            )
          })}
        </div>
      )
    }
    const tileSingleArr = tiles.filter(tile => tile.id === this.props.setTile)
    return (
      <div className='tile-single'>
        {tileSingleArr.map((tile, index) => {
          return (
            <CategoryMenuPanel {...tile} key={index} />
          )
        })}
      </div>
    )
  }
}

CategoryTiles.propTypes = {
  setTile: PropTypes.string
}

export default CategoryTiles
